function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_55_936)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.5101 4.37684L10.9308 3.07772L9.63167 2.49842L10.9308 1.90333L11.5101 0.619995L12.0894 1.90333L13.3885 2.49842L12.0894 3.07772L11.5101 4.37684ZM4.37208 4.37684L3.79278 3.07772L2.49366 2.49842L3.79278 1.90333L4.37208 0.619995L4.95139 1.90333L6.2505 2.49842L4.95139 3.07772L4.37208 4.37684ZM11.5101 11.4525L10.9308 10.1534L9.63167 9.57406L10.9308 8.97898L11.5101 7.69564L12.0894 8.97898L13.3885 9.57406L12.0894 10.1534L11.5101 11.4525ZM2.43129 13.1588L0.834634 11.5772C0.688368 11.4314 0.615234 11.2541 0.615234 11.0452C0.615234 10.8364 0.688368 10.659 0.834634 10.5133L7.40912 3.93879C7.55488 3.79253 7.7322 3.71939 7.94109 3.71939C8.14997 3.71939 8.32729 3.79253 8.47305 3.93879L10.0539 5.53545C10.2002 5.68122 10.2733 5.85854 10.2733 6.06742C10.2733 6.2763 10.2002 6.45363 10.0539 6.59939L3.49523 13.1588C3.34947 13.3046 3.17214 13.3775 2.96326 13.3775C2.75438 13.3775 2.57706 13.3046 2.43129 13.1588ZM2.96326 12.1099L7.51882 7.55438L6.45413 6.48969L1.89857 11.0452L2.96326 12.1099Z",
  fill: "#646464"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_55_936"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "white"
})));

var SvgMaterialWandSm = (_ref) => {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMaterialWandSm, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/material_wand_sm.49df49be.svg";
export { ForwardRef as ReactComponent };